import { addMinutes } from "date-fns";
import { format, formatInTimeZone } from "date-fns-tz";
import { Card, Icon, Tooltip, Typography } from "@/components/atoms";
import { useBookingETA } from "../../BookingTripMap/hooks/useBookingETA";
import { useBookingDriverActivityContext } from "../context";

export const BookingInformation = () => {
  const { tripLog } = useBookingDriverActivityContext();
  const { ETA } = useBookingETA({ tripLog });

  const { job, bookingStops, driverCurrentLocationData } = tripLog;
  const { id, pickupDate, timezone, flightNumber, driver } = job;
  const { pickupLocationData, dropoffLocationData } = bookingStops;
  if (!pickupLocationData || !dropoffLocationData) throw new Error("Missing booking stops data");

  const { address: pickupAddress } = pickupLocationData;
  const { address: dropoffAddress } = dropoffLocationData;

  const showETA = !!driverCurrentLocationData && ETA;

  return (
    <Card className="w-full border border-neutral-mid-gray p-0">
      <div className="rounded-t-lg border-b border-neutral-mid-gray bg-neutral-surface-gray px-5 py-4">
        <Typography variant="title">
          Booking Information
        </Typography>
      </div>
      <div className="rounded-b-lg bg-white space-y-4 p-5 pb-8">
        <div className="flex flex-row items-center gap-2.5">
          <Icon name="Calendar" size="lg" className="flex-shrink-0" />
          <Typography variant="paragraph">{formatInTimeZone(new Date(pickupDate), timezone, "dd-MM-yyyy")}</Typography>
        </div>
        <div className="flex flex-row items-center">
          <Icon name="Clock" size="lg" className="flex-shrink-0" />
          <Typography variant="paragraph" className="ml-2.5">{formatInTimeZone(new Date(pickupDate), timezone, "hh:mm a")}</Typography>
          <Tooltip content={format(new Date(pickupDate), "hh:mm a zzzz")} placement="bottom">
            <Icon name="InfoCircle" size="md" className="flex-shrink-0 rotate-180 ml-1.5" />
          </Tooltip>
        </div>
        {showETA && (
          <div className="flex flex-row items-center gap-2.5">
            <Icon name="Timer1" size="lg" className="flex-shrink-0" />
            <Typography variant="paragraph">{`ETA ${formatInTimeZone(addMinutes(new Date(driverCurrentLocationData.dateTime), ETA), timezone, "hh:mm a")}`}</Typography>
          </div>
        )}
        <div className="flex flex-row gap-2.5">
          <Icon name="Location" size="lg" className="flex-shrink-0" />
          <Typography variant="paragraph">{pickupAddress}</Typography>
        </div>
        <div className="flex flex-row gap-2.5">
          <Icon name="Flag" size="lg" className="flex-shrink-0" />
          <Typography variant="paragraph">{dropoffAddress}</Typography>
        </div>
        {flightNumber && (
          <div className="flex flex-row items-center gap-2.5">
            <Icon name="Airplane" size="lg" className="flex-shrink-0" />
            <Typography variant="paragraph">{`Flight Number: ${flightNumber.toUpperCase()}`}</Typography>
          </div>
        )}
        {driver && (
          <div className="flex flex-row items-center gap-2.5">
            <Icon name="User" size="lg" className="flex-shrink-0" />
            <Typography variant="paragraph">{`${driver.name} - ${driver.vehicle?.model.make}${driver.vehicle?.registrationNumber ? ` (Plate: ${driver.vehicle.registrationNumber})` : ""}`}</Typography>
          </div>
        )}
        <div className="flex flex-row items-center gap-2.5">
          <Icon name="Car" size="lg" className="flex-shrink-0" />
          <Typography variant="paragraph">{job.vehicleType}</Typography>
        </div>
        <div className="flex justify-center w-full">
          <Typography variant="action" className="mt-4 text-info">{`Job reference: J0${id}`}</Typography>
        </div>
      </div>
    </Card>
  );
};
